import angular from "angular";
import template from "./admin-create-instructor.html";
import AdminInstructorCreate from "./admin-create-instructor.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.instructors.create", {
    url: "/create",
    controller: AdminInstructorCreate,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.create", [])
  .config(config)
  .controller("AdminInstructorCreate", AdminInstructorCreate);
